import React, { useEffect } from "react";
import {
  ButtonBase,
  BetaForm as useBetaForm,
  TextInputBase,
  PickerSelectSimple,
} from "@reusejs/react";
import { TimeSlots } from "../../../services/utils/timeslots";
import { bidInterest } from "services";

const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;
const alphabetsOnlyRegEx: RegExp = /^[A-Za-z\s]{1,}[\.]{0,1}[A-Za-z\s]{0,}$/;

const InterestForm = (props: any) => {
  const form = useBetaForm({
    name: "",
    email: "",
    mobile_number: "",
    preferred_date: "",
    preferred_time: { label: "", value: "" },
  });

  const form_constraints = {
    name: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: alphabetsOnlyRegEx,
      },
    },
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    mobile_number: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: mobileNumberRegEx,
      },
    },
    preferred_date: {
      presence: {
        allowEmpty: false,
      },
    },
    preferred_time: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const handleSubmit = async () => {
    try {
      if (form.validate()) {
        let payload = {
          ...form.value,
          property_uuid: props.property_uuid,
          property_id: props.listing_id ? props.listing_id : "",
        };
        if (props.user_uuid !== "") {
          payload["user_uuid"] = props.user_uuid;
        }

        const data: any = await bidInterest(payload);

        if (data) {
          form.setField("name", "");
          form.setField("email", "");
          form.setField("mobile_number", "");
          form.setField("preferred_date", "");
          form.setField("preferred_time", "");
          props.onAction("no");
          if (props.successCallback) {
            props.successCallback();
          }
        }
      }
    } catch (error: any) {}
  };

  return (
    <div className="">
      <div className="py-6 px-8 flex flex-col md:flex-row justify-between flex-wrap">
        <div className="basis-1/2 md:pr-4 mb-4">
          <TextInputBase
            labelBaseProps={{
              label: "Name",
            }}
            name={"name"}
            onChange={(val) => form.setField("name", val)}
            placeholder={"Enter your name"}
            type={"text"}
            error={
              form.errors.get("name") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("name")[0]}
                </p>
              ) : null
            }
            value={form.getField("name")}
            htmlFor={"name"}
          />
        </div>

        <div className="basis-1/2 mb-4">
          <TextInputBase
            labelBaseProps={{
              label: "Email*",
            }}
            name={"email"}
            onChange={(val) => form.setField("email", val)}
            placeholder={"Enter your email"}
            type={"text"}
            error={
              form.errors.get("email") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("email")[0]}
                </p>
              ) : null
            }
            value={form.getField("email")}
            htmlFor={"email"}
          />
        </div>

        <div className="basis-1/2 md:pr-4 mb-4">
          <TextInputBase
            labelBaseProps={{
              label: "Phone Number",
            }}
            name={"mobile_number"}
            onChange={(val) => form.setField("mobile_number", val)}
            placeholder={"Enter your Phone Number"}
            type={"text"}
            error={
              form.errors.get("mobile_number") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("mobile_number")[0]}
                </p>
              ) : null
            }
            value={form.getField("mobile_number")}
            htmlFor={"mobile_number"}
          />
        </div>
      </div>

      <div className="py-6 px-8 flex flex-col md:flex-row justify-between flex-wrap border-t">
        <div className="basis-1/2 md:pr-4 mb-4">
          <div>
            <label className="block text-gray-800 dark:text-gray-100 text-sm font-medium labelBaseClasses_alignment_color_font">
              Preferred Date
            </label>
            <div className="relative rounded-md shadow-sm textInputBaseClasses_wrapper mt-1 textInputBaseClasses_margin">
              <input
                type="date"
                value={form.getField("preferred_date")}
                onChange={(e) => {
                  const currentDate = new Date();
                  const selectedDate = new Date(e.target.value);
                  if (
                    selectedDate > currentDate ||
                    currentDate.toDateString() === selectedDate.toDateString()
                  ) {
                    form.setField("preferred_date", e.target.value);
                  }
                }}
                className="form-input block w-full rounded-md border-gray-300 dark:border-gray-600 focus:border-gray-500 focus:ring-gray-500 font-normal sm:text-sm text-gray-900 dark:text-white bg-white dark:bg-gray-900 textInputBaseClasses_formInput_alignment_width_borderRadius_border_focus_padding_font_textColor_backgroundColor_placeholderColor"
              />
            </div>
          </div>
        </div>

        <div className="basis-1/2 mb-4">
          <PickerSelectSimple
            dataSource={async (c) => {
              return TimeSlots;
            }}
            defaultSelected={
              form.getField("preferred_time").label
                ? [form.getField("preferred_time")]
                : []
            }
            labelBaseProps={{
              label: "Preferred Slot",
            }}
            onChange={(value) => {
              form.setField("preferred_time", value);
            }}
            defaultString="Select your Desired Time Slot"
            valueKey="value"
            multiple={false}
            enableClear={false}
            enableClose={false}
            enableSearch={false}
            error={
              form.errors.get("preferred_time") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("preferred_time")[0]}
                </p>
              ) : null
            }
          />
        </div>
      </div>

      <div className="flex items-center p-8 border-t">
        <div className="w-full mr-2">
          <ButtonBase
            variant="primary"
            type="button"
            label="Schedule a call"
            onClick={() => {
              handleSubmit();
            }}
            buttonBaseClasses={{
              font: "text-sm font-medium",
              backgroundColor: "bg-blue-600 hover:bg-blue-700",
              textColor: "text-white",
              border: "any",
              width: "w-full",
              padding: "px-4 py-3",
            }}
          />
        </div>
        <ButtonBase
          variant="primary"
          type="button"
          label="Skip"
          onClick={() => {
            if (props.onAction) {
              props.onAction("no");
            }
          }}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-transparent",
            textColor: "text-black hover:text-blue-700",
            border: "border border-black border hover:border-blue-700",
            width: "w-full",
            padding: "px-4 py-3",
          }}
        />
      </div>
    </div>
  );
};

export default InterestForm;
